const rankings = [
  {
    rank: 1,
    title: '51吃瓜爆料每日大赛评选结果遭质疑',
    heat: '128.5万',
    change: '+12.3万',
    tag: '爆',
  },
  {
    rank: 2,
    title: '电竞豪门深夜官宣：核心选手解约',
    heat: '96.2万',
    change: '+8.7万',
    tag: '热',
  },
  {
    rank: 3,
    title: '某顶流综艺被曝剪辑恶意引导舆论',
    heat: '83.7万',
    change: '+5.4万',
    tag: '热',
  },
  {
    rank: 4,
    title: '游戏公司CEO内部信泄露：裁员30%',
    heat: '71.4万',
    change: '-2.1万',
    tag: '',
  },
  {
    rank: 5,
    title: '体育联赛裁判考核体系遭匿名举报',
    heat: '65.8万',
    change: '+15.6万',
    tag: '新',
  },
];

export default function Ranking() {
  return (
    <section id="ranking" className="section-py bg-background-100">
      <div className="section-container">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center gap-3">
            <div className="w-1 h-6 rounded-full bg-accent-500"></div>
            <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">
              爆料榜单
            </h2>
          </div>
          <span className="text-xs text-foreground-500 flex items-center gap-1">
            <i className="ri-fire-line text-accent-500"></i>
            24小时热榜
          </span>
        </div>

        <div className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden">
          {rankings.map((item, idx) => (
            <div
              key={idx}
              className={`flex items-center gap-4 p-4 cursor-pointer hover:bg-background-100 transition-colors ${
                idx < rankings.length - 1 ? 'border-b border-background-200/50' : ''
              }`}
            >
              <span className={`text-2xl font-bold font-heading w-10 text-center shrink-0 ${
                item.rank === 1 ? 'text-accent-500' :
                item.rank === 2 ? 'text-primary-500' :
                item.rank === 3 ? 'text-accent-600' :
                'text-foreground-400'
              }`}>
                {String(item.rank).padStart(2, '0')}
              </span>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="text-sm font-semibold text-foreground-900 truncate font-heading">{item.title}</h3>
                  {item.tag && (
                    <span className={`text-xs font-bold px-1.5 py-0.5 rounded shrink-0 ${
                      item.tag === '爆' ? 'bg-primary-500 text-background-50' :
                      item.tag === '热' ? 'bg-accent-500 text-background-50' :
                      'bg-accent-100 text-accent-700'
                    }`}>
                      {item.tag}
                    </span>
                  )}
                </div>
                <div className="flex items-center gap-3 mt-1">
                  <span className="text-xs text-foreground-500">{item.heat} 阅读</span>
                  <span className={`text-xs ${item.change.startsWith('+') ? 'text-primary-600' : 'text-foreground-400'}`}>
                    {item.change}
                  </span>
                </div>
              </div>

              <div className="shrink-0 text-foreground-400">
                <i className="ri-arrow-right-s-line"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}